const c = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, k = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (t) => `@media (min-width:${c[t]}px)`
};
function m(t, e, n) {
  const s = t.theme || {};
  if (Array.isArray(e)) {
    const r = s.breakpoints || k;
    return e.reduce((u, o, i) => (u[r.up(r.keys[i])] = n(e[i]), u), {});
  }
  if (typeof e == "object") {
    const r = s.breakpoints || k;
    return Object.keys(e).reduce((u, o) => {
      if (Object.keys(r.values || c).indexOf(o) !== -1) {
        const i = r.up(o);
        u[i] = n(e[o], o);
      } else {
        const i = o;
        u[i] = e[i];
      }
      return u;
    }, {});
  }
  return n(e);
}
function y(t = {}) {
  var e;
  return ((e = t.keys) == null ? void 0 : e.reduce((s, d) => {
    const r = t.up(d);
    return s[r] = {}, s;
  }, {})) || {};
}
function f(t, e) {
  return t.reduce((n, s) => {
    const d = n[s];
    return (!d || Object.keys(d).length === 0) && delete n[s], n;
  }, e);
}
export {
  y as createEmptyBreakpointObject,
  m as handleBreakpoints,
  f as removeUnusedBreakpoints,
  c as values
};
